import { AuthContextFactory } from './AuthContextFactory';

export const authContextDependencies = {
  authInteractor: AuthContextFactory.authInteractor(),
};
